/**
 * Created by fworld on 2019/9/27.
 */
const screen = [
    {
        name: 'delivery.devices.screenManager',
        path: 'screenManager',
        meta: {title: '屏显管理', keepAlive: true},
        component: () => import('@/pages/Delivery/Device/ScreenManager'),
    },
    {
        name: 'delivery.devices.screenManager.logo.detail',
        path: 'screenManager/logo/detail',
        meta: {title: 'LOGO详情'},
        component: () => import('@/pages/Delivery/Device/ScreenManager/Logo/detail'),
    },
    {
        name: 'delivery.devices.screenManager.makePicture.detail',
        path: 'screenManager/makePicture/detail',
        meta: {title: '制作过程详情'},
        component: () => import('@/pages/Delivery/Device/ScreenManager/MakePicture/detail'),
    },
    {
        name: 'delivery.devices.screenManager.makeVideo.detail',
        path: 'screenManager/makePicture/detail',
        meta: {title: '制作过程详情'},
        component: () => import('@/pages/Delivery/Device/ScreenManager/MakeVideo/detail'),
    },
    {
        name: 'delivery.devices.screenManager.screenSaver.detail',
        path: 'screenManager/screenSaver/detail',
        meta: {title: '待机屏保详情'},
        component: () => import('@/pages/Delivery/Device/ScreenManager/ScreenSaver/detail'),
    },

]

export default screen